import {
  GET_USERS_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS
} from '../actions/users'

const initialState = {
  isFetching: false,
  items: []
}

export function users(state = initialState, action) {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case GET_USERS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.users
      })
    case GET_USERS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        items: []
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js